/* eslint-disable react/no-danger */ import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var CONTEXT = {
    "@context": "https://schema.org"
};
var StructuredData = function(param) {
    var type = param.type, data = param.data, _includeContext = param.includeContext, includeContext = _includeContext === void 0 ? false : _includeContext;
    var context = includeContext ? CONTEXT : {};
    var structuredData = _object_spread({
        "@type": type
    }, data, context);
    return /*#__PURE__*/ _jsx("script", {
        id: "jsonid-".concat(type.toLowerCase()),
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(structuredData)
        }
    });
};
export { StructuredData };
